export { AdTypeBadge, AdTypeBadgeProps } from './AdTypeBadge';
